// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ProgressBar.css */
.progress-bar-container {
  width: 100%;
  background-color: #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}

.progress-bar {
  height: 20px;
  background-color: #76c7c0;
  border-radius: 8px;
  text-align: center;
  color: white;
  line-height: 20px; /* Alinea el texto verticalmente */
  transition: width 0.3s ease-in-out;
}

.tb{
  border:1px solid  #0000;
  width: 100%;
}
.tb body tr {
  width: 100%;
  
}
.td-consolidado > * {
  font-size: 16px;
  padding: 5px;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/reportes/index.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB,EAAE,kCAAkC;EACrD,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,WAAW;;AAEb;AACA;EACE,eAAe;EACf,YAAY;AACd","sourcesContent":["/* ProgressBar.css */\n.progress-bar-container {\n  width: 100%;\n  background-color: #e0e0e0;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.progress-bar {\n  height: 20px;\n  background-color: #76c7c0;\n  border-radius: 8px;\n  text-align: center;\n  color: white;\n  line-height: 20px; /* Alinea el texto verticalmente */\n  transition: width 0.3s ease-in-out;\n}\n\n.tb{\n  border:1px solid  #0000;\n  width: 100%;\n}\n.tb body tr {\n  width: 100%;\n  \n}\n.td-consolidado > * {\n  font-size: 16px;\n  padding: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
